<template>
  <section>
    <h1>TRENDING NOW 🔥</h1>
    <h2>Los más buscados</h2>
  </section>
  <section class="products-section">
    <div class="cards-container" ref="carousel">
      <div class="product-card" v-for="(item, index) in duplicatedProducts" :key="index">
        <img class="heart-badge" src="@/assets/banners/bestseller.png" alt="Bestseller" />

        <div class="image-wrapper">
          <img :src="item.image" :alt="item.name" />
        </div>

        <h3>{{ item.name }}</h3>
        <p>{{ item.subtitle }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const carousel = ref(null)

const products = [
  {
    name: 'Soulmates Palette', subtitle: 'Charlotte Tilbury',
    image: new URL( '@/assets/bestsellers/makeup.jpg', import.meta.url ).href
  },
  {
    name: 'Body Mist', subtitle: 'Victoria’s Secret',
    image: new URL( '@/assets/bestsellers/bodymist_vs.jpeg', import.meta.url ).href
  },
  {
    name: 'Joystick Blush Stick', subtitle: 'Marc Jacobs Beauty',
    image: new URL( '@/assets/bestsellers/marcjacobs_joystick.jpeg', import.meta.url ).href
  },
  {
    name: 'Crème & Powder Blush Duo', subtitle: 'Patrick Ta',
    image: new URL('@/assets/bestsellers/sheleftmeonred_patrickta.jpeg', import.meta.url ).href
  },
  {
    name: 'Pocket Blush', subtitle: 'Rhode',
    image: new URL('@/assets/bestsellers/pocketblush_rhode.jpeg', import.meta.url ).href
  }
]

const duplicatedProducts = computed(() => [ ...products, ...products ])

onMounted(() => {
  const moveCarousel = () => {
    if (!carousel.value) return

    carousel.value.scrollLeft += 1

    const maxScroll =
      carousel.value.scrollWidth -
      carousel.value.clientWidth

    // reinicio infinito suave
    if (
      carousel.value.scrollLeft >=
      maxScroll / 2
    ) {
      carousel.value.scrollLeft = 0
    }
    requestAnimationFrame(moveCarousel)
  }

  moveCarousel()
})
</script>

<style scoped>
.products-section {
  background: #11146d;
  padding: 10px 0;
  overflow: hidden;
}

/* CARRUSEL */
.cards-container {
  display: flex;
  gap: 30px;
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 20px 50px;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: auto;
  scrollbar-width: none;
}

.cards-container::-webkit-scrollbar {
  display: none;
}

/* CARD */
.product-card {
  flex: 0 0 auto;
  width: 230px;
  text-align: center;
  position: relative;
}

/* IMAGEN */
.image-wrapper {
  width: 230px;
  height: 300px;
  border-radius: 999px;
  overflow: hidden;
  transition: transform .3s ease;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.product-card:hover .image-wrapper {
  transform: translateY(-8px);
}

/* TEXTO */
h1{
  margin-top: 3rem;
  text-align: center;
  font-size: clamp(3rem, 4vw, 20rem);
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: "Magistral_Bold";
  color: #BAECFF;
}
h2 {
  margin-top: 1px;
  font-size: clamp(1.2rem, 1.5vw, 2rem);
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: "Magistral_Bold";
  color: #daeff7;
  text-align: center;
}
h3 {
  margin-top: 14px;
  font-size: clamp(1rem, 1.5vw, 2rem);
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: "Magistral_Bold";
  color: #BAECFF;
  text-align: center;
}

p {
  font-size: clamp(.9rem, 1vw, 1rem);
  opacity: .75;
  margin-top: 4px;
  color: aliceblue;
}

/* BADGE */
.heart-badge {
  position: absolute;
  width: clamp(70px, 8vw, 85px);
  z-index: 10;
  top: -10px;
  left: 0;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .products-section {
    padding: 0px 0;
  }

  .cards-container {
    gap: 18px;
    padding: 20px;
  }

  .product-card {
    width: 150px;
  }

  .image-wrapper {
    width: 150px;
    height: 210px;
  }

  .heart-badge {
    width: 55px;
    top: -5px;
  }

  h3 {
    font-size: .9rem;
  }

  p {
    font-size: .75rem;
  }

  p.bestsell{

  }
}
</style>